import { render } from "./gsrbr0603.vue?vue&type=template&id=b8a33ac6&scoped=true"
import script from "./gsrbr0603.vue?vue&type=script&lang=js"
export * from "./gsrbr0603.vue?vue&type=script&lang=js"

import "./gsrbr0603.vue?vue&type=style&index=0&id=b8a33ac6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8a33ac6"]])

export default __exports__